<template>
  <AFixedHeader :offset-top="20">
    <template #header="{ reachTop, isMounted, dirtyScroll, scrollingToTop }">
      <TheHeader :reachTop :isMounted :dirtyScroll :scrollingToTop />
    </template>
  </AFixedHeader>
  <div class="sm:pt-[125px] pt-[115px]">
    <ASiteContainer class="-mt-6">
      <ABreadcrumb />
    </ASiteContainer>
    <slot />
    <hr class="my-12" />
    <TheFooter />
    <AScrollToTop />
    <GooeyMenu class="fixed sm:bottom-0 sm:right-2 right-0 bottom-0 z-10" />
  </div>
</template>

<script lang="ts" setup>
const route = useRoute()
const { t } = useI18n()
const domain = useRequestURL().origin

const i18nHead = useLocaleHead({
  key: 'id',
  seo: true,
})

useHead({
  link: [...(i18nHead.value.link || [])],
  titleTemplate: (title) => {
    const defaultTitle = t('general.defaultTitle')
    if (route.path === '/')
      return defaultTitle
    return title ? `${title} - Quotatrip` : defaultTitle
  },
})

useSeoMeta({
  description: t('general.description'),
  keywords: t('general.keywords'),
  ogImage: `${domain}/images/image_og.png`,
  ogSiteName: t('general.defaultTitle'),
  ogType: 'website',
})
</script>

<style></style>
